import { hFetch } from './hFetch';

type ChecklistType = 'onboarding' | 'offboarding' | 'training';
type ChecklistStatus = 'enabled' | 'disabled';

type ListTaskChecklistsArgs = {
  type?: ChecklistType;
  status?: ChecklistStatus;
};
export const listTaskChecklists = async ({ type, status }: ListTaskChecklistsArgs) => {
  const params = new URLSearchParams();
  if (type) params.append('checklist_type', type);
  if (status) params.append('status', status);
  return (await hFetch({ url: `/api/task_checklists?${params.toString()}` })) as { records: TaskChecklist[] };
};

export const createTaskChecklist = async (newChecklist: TaskChecklist) => {
  return await hFetch({ url: '/api/task_checklists', method: 'POST', payload: { task_checklist: newChecklist } });
};

export const updateTaskChecklist = async (id: number, name: string) => {
  return await hFetch({ url: `/api/task_checklists/${id}`, method: 'PATCH', payload: { task_checklist: { name } } });
};

export const deleteTaskChecklist = async (id: number) => {
  return await hFetch({ url: `/api/task_checklists/${id}`, method: 'DELETE' });
};

export type TaskChecklist = {
  id: number;
  team_id: number;
  checklist_type: ChecklistType;
  checklist_tasks: ChecklistTask[];
  name: string;
  primary_user_role: string;
  status: ChecklistStatus;
  created_at: string;
  updated_at: string;
};

export type ChecklistTask = {
  id: number;
  name: string;
};
